import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import externalUrl from '@Utils/ExternalUrl';
import UtilsHelper from '@Components/Results/services/utils-helper.service';
import { LinkElement } from '@els/els-react--link-element';

const DocumentCustomLink = forwardRef(({ citation, getTrackingAttrs }, ref) => {
  if (!citation.fullTextUrl) {
    return null;
  }

  // Attach ref to the anchor element
  return (
    <LinkElement
      ref={ref}
      isExternal
      data-e2e="e2e-full-text-button"
      href={externalUrl(citation.fullTextUrl)}
      className="e2e-full-text u-els-font-size-base"
      {...getTrackingAttrs(
        {
          'data-tracking-type': 'linkout',
          'data-tracking-action': 'full text',
        },
        true
      )}
      data-doi={UtilsHelper.stripTags(citation.doi)}>
      Full Text
    </LinkElement>
  );
});

DocumentCustomLink.displayName = 'DocumentCustomLink';

DocumentCustomLink.propTypes = {
  citation: PropTypes.object.isRequired,
  // for analytics
  getTrackingAttrs: PropTypes.func.isRequired,
};

export default DocumentCustomLink;
